export default __webpack_public_path__ + "static/media/intro3.69bf609e.mp3";